import { useEffect, useState } from 'react';
import axios from 'axios';

// const domContainer = document.querySelector('#constructor_app'),
//     sectionId = domContainer?.getAttribute('data-section-id');

async function getCollectionsData() {
    // const addParams = sectionId ? 'sectionId=' + sectionId : '';
    // return await axios.get('https://fresq.ru/app/ajax/?type=collections&' + addParams);
    return await axios.get('https://fresq.ru/app/ajax/?type=collections&');
}

export const useCollectionsData = () => {
    const [collectionsData, setCollectionsData] = useState({
        // elementId: localStorage.getItem('elementId') != null ? +localStorage!.getItem('elementId')! : 1006,
        elementId: 1006,
        sectionId: 32,
        prevSectionId: 32,
        items: [
            {
                id: 0,
                img: '',
                name: '',
                items: [
                    {
                        id: 0,
                        img: '',
                        name: ''
                    },
                ],
            },
        ],


    });

    useEffect(() => {
        let isSubscribed = true;
        if(isSubscribed) {
            const fetchData = async () => {
                await getCollectionsData().then(response => {
                    const url = new URL(window.location.href),
                        paramElementId = url.searchParams.get('itemId'),
                        paramSectionId = url.searchParams.get('sectionId');

                    const newCollectionsData = {
                        items: response.data,
                        elementId: paramElementId ? Number(paramElementId) : collectionsData.elementId,
                        sectionId: paramSectionId ?  Number(paramSectionId) : collectionsData.sectionId,
                        prevSectionId: collectionsData.prevSectionId
                    };

                    setCollectionsData(newCollectionsData);
                });
            }

            fetchData()
                .catch(console.error);
        }
        return () => {
            isSubscribed = false;
        };
    }, []);

    return [collectionsData];
};
